<template>
  <scroll-center-dialog v-model="open" :loading="loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <div class="field_label__text">ТЕКУЩИЙ ПАРОЛЬ:</div>
    <v-text-field
        class="dialog__fields"
        color="#3254B9"
        base-color="#313743"
        variant="solo"
        :append-inner-icon="show1 ? 'visibility_off' : 'visibility'"
        :type="show1 ? 'text' : 'password'"
        :title="passwordMsg"
        :rules="[rules.required, rules.passStr, rules.symbControl]"
        @click:appendInner="show1 = !show1"
        v-model="data.old_password"
        :loading="loading"
        :error="hasError('old_password')"
        :error-messages="getError('old_password')"
    >
      <template v-slot:label></template>
    </v-text-field>
    <div class="field_label__text">НОВЫЙ ПАРОЛЬ:</div>
    <v-text-field
        class="dialog__fields"
        color="#3254B9"
        base-color="#313743"
        variant="solo"
        :append-inner-icon="show2 ? 'visibility_off' : 'visibility'"
        :type="show2 ? 'text' : 'password'"
        :title="passwordMsg"
        :rules="[rules.required, rules.passStr, rules.symbControl]"
        @click:appendInner="show2 = !show2"
        v-model="data.new_password"
        :loading="loading"
        :error="hasError('new_password')"
        :error-messages="getError('new_password')"
    >
      <template v-slot:label></template>
    </v-text-field>
    <div class="field_label__text">ПОВТОРИТЕ НОВЫЙ ПАРОЛЬ:</div>
    <v-text-field
        class="dialog__fields"
        color="#3254B9"
        base-color="#313743"
        variant="solo"
        :append-inner-icon="show3 ? 'visibility_off' : 'visibility'"
        :type="show3 ? 'text' : 'password'"
        :title="passwordMsg"
        :rules="[rules.repeatPass]"
        @click:appendInner="show3 = !show3"
        v-model="data.repeat_new_password"
        :loading="loading"
        :error="hasError('repeat_new_password')"
        :error-messages="getError('repeat_new_password')"
    >
      <template v-slot:label></template>
    </v-text-field>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog"
import { mapActions } from "vuex"

export default {
  name: "UserPasswordDialog",
  props: {
    value: Boolean,
  },
  components: {
    ScrollCenterDialog,
  },
  mixins: [FormErrorsMixin],
  data () {
    return {
      open: false,
      loading: false,
      data: {
        old_password: '',
        new_password: '',
        repeat_new_password: '',
      },
      show1: false,
      show2: false,
      show3: false,
      passwordMsg: "Пароль должен иметь размер не менее 8 символов, содержать латинские буквы нижнего, верхнего регистров, а так же цифру. Может содержать только символы от a до Z, цифры от 0 до 9",
      rules: {
        required: value => !!value || 'Введите пароль',
        symbControl: value => this.symbControl(value) || 'Некорректный ввод',
        passStr: value => {
          const pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!#$%&'*+\-.:<=>?@^_`|~]{8,}$/
          return pattern.test(value) || this.passwordMsg
        },
        repeatPass: value => {
          if (value !== null) {
            return this.data.new_password === value || 'Пароли не совпадают'
          } else {
            return 'Подтвердите ввод пароля'
          }
        },
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open: {
      immediate: true,
      handler () {
        this.$emit('input', this.open)
      }
    }
  },
  computed: {
    form_title () {
      return 'пароль'
    },
  },
  methods: {
    ...mapActions({
      changePass: 'personal_account/users/changePass'
    }),
    symbControl: function (value) {
      if (value === null) {
        return true
      }
      return !(value.includes(' ') || value.includes('\n'))
    },
    save () {
      this.loading = true
      this.changePass({
        data: this.data,
        finalizer: () => {
          this.$emit('save')
          this.loading = false
        },
        catcher: (val) => {
          this.mapErrors(val)
          this.loading = false
        },
      })
    },
    close () {
      this.$emit('close')
    },
  },
  created () {}
}
</script>

<style scoped lang="scss">
.dialog__fields {
  margin-bottom: 5px;
}

.field_label__text {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #3254B9;
}

@media screen and (max-width: 768px) {
  .field_label__text {
    font-size: 12px;
    line-height: 15px;
  }
}
</style>
